import { Permission, Role, Token, User } from '../../core/entities/user.entity';
import { LoginResponse } from '../interfaces/login.response';

export class LoginMapper {
   static mapResponseToUser(response: LoginResponse): User {
      return {
         id: response.data.user.id,
         userName: response.data.user.user_name,
         name: response.data.user.name,
         lastName: response.data.user.last_name,
         admissionDate: response.data.user.admission_date,
         identification: response.data.user.identification,
         birthDate: response.data.user.birth_date,
         phone: response.data.user.phone,
         email: response.data.user.email,
         profession: response.data.user.profession,
         entrepreneurship: response.data.user.entrepreneurship,
         mainSkill: response.data.user.main_skill,
         secondarySkill: response.data.user.secondary_skill,
         createdAt: response.data.user.created_at,
         updatedAt: response.data.user.updated_at,
         emailVerifiedAt: response.data.user.email_verified_at ? new Date(response.data.user.email_verified_at) : null,
         isEmailVerified: response.data.is_email_verified !== undefined ? response.data.is_email_verified : response.data.user.email_verified_at !== null,
      };
   }

   static mapResponseToToken(response: LoginResponse): Token {
      return {
         accessToken: response.data.access_token,
         tokenType: response.data.token_type,
         expiresIn: response.data.expires_in,
         user: this.mapResponseToUser(response),
      };
   }

   static mapResponseToRoles(response: LoginResponse): Role[] {
      if (!response.data.roles) return [];
      return response.data.roles.map((role) => {
         return {
            id: role.pivot?.role_id,
            name: role.name,
            displayName: role.display_name,
         };
      });
   }

   static mapResponseToPermissions(response: LoginResponse): Permission[] {
      if (!response.data.permissions) return [];
      return response.data.permissions.map((permission) => {
         return {
            name: permission.name,
            displayName: permission.display_name,
         };
      });
   }
}
